import React, { useState } from "react";
import { RouteComponentProps } from "@reach/router";

import { newsletter, text, title, button, leftWrapper, link } from "./newsletter-options.module.scss";
import { mainGrid } from "../../../styles/grid.module.scss";
import Envelope from "../../../assets/images/svg/envelope.svg";
import Heart from "../../../assets/images/svg/heart.svg";
import useUser from "../../auth/hooks/use-user";

import Section from "../../../components/molecules/section";
import AccountTitle from "../atoms/account-title";
import Button from "../../../components/atoms/button";
import TwoBoxSection from "../../../components/organisms/sections/common/two-box-section";
import { newsletterUnsubscribe } from "../../../services/user-services";
import { set } from "lodash";
import RadioGroup from "../../../components/atoms/form/radio-group";
import { IUnsubscribe } from "../../../models/unsubscribe.model";

type TNewsletterOptionsProps = {
    token: string;
} & RouteComponentProps;


export default function NewsletterOptions(props: TNewsletterOptionsProps) {
    const { resendActivationEmail } = useUser();
    const { token } = props;
    const [mainTextView, setMainTextView] = useState(true);
    const [unsubscribeSuccess, setUnsubscribeSuccess] = useState(false);

    const [unsubscribeReason, setUnsubscribeReason] = useState<string>("");
    const [unsubscribeOtherText, setUnsubscribeOtherText] = useState<string>("");

    const handleUnpsubscribe = () => {
        console.log('Unsubscribe with token: ', token);
        console.log('Reason: ', unsubscribeReason);
        console.log('Other text: ', unsubscribeOtherText);
        const payload: IUnsubscribe = {
            token: token || "",
            reason: unsubscribeReason,
            otherText: unsubscribeReason === "other" ? unsubscribeOtherText : undefined,
        };
        newsletterUnsubscribe(payload).then((response) => {
            setMainTextView(false);
            setUnsubscribeSuccess(response);
        });
    };

    const handleBackToAccount = () => {
        console.log('Back to account');
        window.location.href = "/generator/wyczaruj-stylizacje";
    };
    const handleBackToMain = () => {
        console.log('Back to account');
        window.location.href = "/";
    };

    const textContent = mainTextView ? (
        <div>
            <div className={text}>
                <p>Hej, zanim klikniesz <strong>„wypisz”</strong>— chcemy tylko zapytać o jedno:</p>
                <p>dlaczego chcesz zrezygnować z newslettera?</p>
                <p>Twoja opinia naprawdę pomoże nam być lepszymi</p>
                <p>🪞 Wybierz jedną z odpowiedzi:</p>
                <label><input type="radio" id="unsubscribe-reason" name="unsubscribe-reason" value="too-many-emails"
                    checked={unsubscribeReason === "too-many-emails"}
                    onChange={(e) => setUnsubscribeReason(e.target.value)}
                ></input>Dostaję zbyt dużo maili</label>
                <br />
                <label><input type="radio" id="unsubscribe-reason" name="unsubscribe-reason" value="not-relevant"
                    checked={unsubscribeReason === "not-relevant"}
                    onChange={(e) => setUnsubscribeReason(e.target.value)}
                ></input>Treści mnie nie interesują</label>
                <br />
                <label><input type="radio" id="unsubscribe-reason" name="unsubscribe-reason" value="too-frequent"
                    checked={unsubscribeReason === "too-frequent"}
                    onChange={(e) => setUnsubscribeReason(e.target.value)}
                ></input>Za rzadko / za często wysyłacie</label>
                <br />
                <label><input type="radio" id="unsubscribe-reason" name="unsubscribe-reason" value="not-enough-time"
                    checked={unsubscribeReason === "not-enough-time"}
                    onChange={(e) => setUnsubscribeReason(e.target.value)}
                ></input>Nie mam czasu na czytanie</label>
                <br />
                <label><input type="radio" id="unsubscribe-reason" name="unsubscribe-reason"
                    checked={unsubscribeReason === "other"}
                    onChange={(e) => setUnsubscribeReason(e.target.value)} value="other"></input>Inny powód (napisz poniżej)</label>
                <br />
                <input type="text" id="unsubscribe-other-text" name="unsubscribe-other-text" placeholder="Twój powód..."
                    value={unsubscribeOtherText}
                    onChange={(e) => setUnsubscribeOtherText(e.target.value)}
                    style={{ display: unsubscribeReason === "other" ? "block" : "none", marginTop: "8px", width: "100%" }}
                ></input>
                <p>Dziękujemy, że pomagasz nam tworzyć coś lepszego ✨</p>
            </div>
            <div>
                <Button color="primary" type="filled" onClick={handleBackToAccount} htmlType="button" className={button}>
                    💜 Zostaję jednak z Wami!
                </Button>
                <a onClick={handleUnpsubscribe} className={link}>
                    Wypisz mnie z newslettera
                </a>
            </div>
        </div>
    ) : (
        <div>
            {unsubscribeSuccess ? (
                <div className={text}>
                    <p>Dziękujemy — zostałeś wypisany z newslettera.</p>
                    <Button color="primary" type="filled" onClick={handleBackToMain} htmlType="button" className={button}>
                        Powrót do strony głównej
                    </Button>
                </div>
            ) : (
                <div className={text}>
                    <p>Przetwarzamy Twoje wypisanie... Jeśli coś poszło nie tak, spróbuj ponownie.</p>
                    <div>
                        <Button color="primary" type="filled" onClick={handleBackToAccount} htmlType="button" className={button}>
                            Wróć
                        </Button>
                        <a onClick={handleUnpsubscribe} className={link}>
                            Spróbuj ponownie wypisać
                        </a>
                    </div>
                </div>
            )}
        </div>
    );

    return (
        <div className={mainGrid}>
            <TwoBoxSection
                withTopPadding={false}
                classNameLeftWrapper={leftWrapper}
                title={"Zanim się wypiszesz…"}
                text={textContent}
                quoteText2={""}
                quoteSubtext2={""}
            />
            {/* <Section column="narrow" className={newsletter}>
                <AccountTitle className={title}></AccountTitle>
                <Heart />

            </Section> */}
        </div>
    );
}
